let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3RG3j")).then(() => parcelRequire('k9nal'));